export default __webpack_public_path__ + "static/media/twitter.f1af20c4.svg";